import { connect } from 'react-redux';

import { StoreState } from '../../../reducers';
import ResourcesLoader from '../../../components/Editor/ResourcesLoader';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			pagesController: { spreads, currentSpreadIndex, prevSpreadIndex },
			pages,
			resources: { css, themesCss, scripts },
			externalResources,
			isAccessibleVersion,
		},
	} = state;

	const currentSpreadFirstPage = !isAccessibleVersion ? spreads[currentSpreadIndex][0] : currentSpreadIndex + 1;
	const prevSpreadFirstPage = !isAccessibleVersion ? spreads[prevSpreadIndex][0] : prevSpreadIndex + 1;
	const page = pages[currentSpreadFirstPage] ? currentSpreadFirstPage : prevSpreadFirstPage;
	const { externalId } = pages[page];

	return {
		css: externalId ? externalResources[externalId].css : css,
		themesCss: externalId ? externalResources[externalId].themesCss : themesCss,
		scripts: externalId ? externalResources[externalId].scripts : scripts,
	};
};

export default connect(mapStateToProps)(ResourcesLoader);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/ResourcesLoader/index.tsx